import { useAtomValue } from 'jotai';
import { useSidePanel } from '../side-panel-provider';
export const useAnnotationLabel = () => {
  const {
    annotationLabelsAtom
  } = useSidePanel();
  const annotationLabels = useAtomValue(annotationLabelsAtom);
  return annotationLabels;
};